(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ugc-pet-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class UgcPetCarousel {
    constructor(el) {
      this.section      = el;
      this.track        = el.querySelector('.ugc-pets__track');
      this.cards        = Array.from(el.querySelectorAll('.ugc-pets__card'));
      this.prevBtn      = el.querySelector('.ugc-pets__arrow--prev');
      this.nextBtn      = el.querySelector('.ugc-pets__arrow--next');
      this.dots         = Array.from(el.querySelectorAll('.ugc-pets__dot'));
      this.autoPlay     = el.dataset.autoPlay === 'true';
      this.autoSpeed    = parseInt(el.dataset.autoSpeed, 10) || 3000;
      this.currentIndex = 0;
      this.timer        = null;
      this.isDragging   = false;
      this.startX       = 0;
      this.dragDelta    = 0;

      if (!this.track || this.cards.length === 0) return;

      this._calcVisible();
      this._bindEvents();
      if (this.autoPlay) this._startAutoPlay();
    }

    /* ── How many cards fit at once ── */
    _calcVisible() {
      const wrapper = this.section.querySelector('.ugc-pets__track-wrapper');
      if (!wrapper || this.cards.length === 0) return;
      const cardW   = this.cards[0].getBoundingClientRect().width;
      const wrapW   = wrapper.getBoundingClientRect().width;
      const gap     = 20;
      this.visibleCount = Math.max(1, Math.round((wrapW + gap) / (cardW + gap)));
      this.maxIndex     = Math.max(0, this.cards.length - this.visibleCount);
    }

    /* ── Move to index ── */
    _goTo(index) {
      this._calcVisible();
      this.currentIndex = Math.min(Math.max(index, 0), this.maxIndex);
      const cardW  = this.cards[0].getBoundingClientRect().width;
      const gap    = 20;
      const offset = this.currentIndex * (cardW + gap);
      this.track.style.transform = `translateX(-${offset}px)`;
      this._updateDots();
    }

    _updateDots() {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('ugc-pets__dot--active', i === this.currentIndex);
      });
    }

    /* ── Auto-play ── */
    _startAutoPlay() {
      this._stopAutoPlay();
      this.timer = setInterval(() => {
        const next = this.currentIndex >= this.maxIndex ? 0 : this.currentIndex + 1;
        this._goTo(next);
      }, this.autoSpeed);
    }

    _stopAutoPlay() {
      if (this.timer) clearInterval(this.timer);
    }

    /* ── Events ── */
    _bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => {
        this._goTo(this.currentIndex - 1);
        if (this.autoPlay) this._startAutoPlay();
      });

      if (this.nextBtn) this.nextBtn.addEventListener('click', () => {
        this._goTo(this.currentIndex + 1);
        if (this.autoPlay) this._startAutoPlay();
      });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this._goTo(i);
          if (this.autoPlay) this._startAutoPlay();
        });
      });

      /* Pause on hover */
      this.section.addEventListener('mouseenter', () => this._stopAutoPlay());
      this.section.addEventListener('mouseleave', () => {
        if (this.autoPlay) this._startAutoPlay();
      });

      /* Touch / drag swipe */
      this.track.addEventListener('pointerdown', (e) => {
        this.isDragging = true;
        this.startX     = e.clientX;
        this.track.setPointerCapture(e.pointerId);
        this._stopAutoPlay();
      });

      this.track.addEventListener('pointermove', (e) => {
        if (!this.isDragging) return;
        this.dragDelta = e.clientX - this.startX;
      });

      this.track.addEventListener('pointerup', () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        if (this.dragDelta < -50) this._goTo(this.currentIndex + 1);
        else if (this.dragDelta > 50) this._goTo(this.currentIndex - 1);
        this.dragDelta = 0;
        if (this.autoPlay) this._startAutoPlay();
      });

      /* Recalculate on resize */
      window.addEventListener('resize', () => {
        this._calcVisible();
        this._goTo(this.currentIndex);
      });
    }
  }

  /* Boot all carousels on the page */
  document.querySelectorAll('.ugc-pets').forEach(el => new UgcPetCarousel(el));
})();

  } catch(e) { console.error(e); }
})();
})();
